/**
 * Pages anyone can open without signing in.
 *
 * A session stored in the browser can be stale. On these pages it must never
 * trigger a session check or a redirect to the sign-in page: the emailed links
 * (email verification, application status, activation) carry one-time tokens,
 * and the certificate check is opened from a QR code by people who may once
 * have signed in on the same browser.
 *
 * Keep in step with the public routes in App.jsx.
 */
const PUBLIC_EXACT = new Set([
  '/',
  '/login',
  '/register',
  '/register/verify',
  '/activate',
  '/terms',
  '/platform/login',
  '/platform/auth/link',
]);

const PUBLIC_PREFIXES = ['/register/status/', '/verify/'];

export function isPublicPath(pathname = window.location.pathname) {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return PUBLIC_EXACT.has(path) || PUBLIC_PREFIXES.some((p) => path.startsWith(p));
}
